export const WidgetMixin = {
    props: {
        data: {
            default: {},
            require :false
        },
        dataUrl:{
            require : false
        },

    }
};
